export class LocalstorageConstant {
  public static get TOKEN(): string { return 'TOKEN'; }
}

